import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  padding-block: 0 2rem;
  
  gap: 1rem;
  display: flex;

  @media (max-width: 1110px) {
    flex-direction: column;
  }
`

export const Card = styled.div`
  width: 100%;
  padding: 0.75rem;
  
  display: flex;
  
  border-radius: 0.5rem;
  background-color: ${theme.colors.gray.Cinza_2};
  justify-content: space-between;

  .texts {
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
    
    h1 {
      color: white;
      font-weight: 800;
      font-size: 1.25rem;
    }

    p {
      color: #BAC1CF;
      font-weight: 600;
      font-size: 0.5625rem;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
    }

    >div {
      display: flex;
      align-items: center;

      h2 {
        color: white;
        font-weight: 400;
        font-size: 0.875rem;
      }

      span {
        color: #BAC1CF;
        font-weight: 600;
        font-size: 0.5625rem;
        letter-spacing: 0.1rem;
        text-transform: uppercase;
      
        ::before {
          content: "•";
          margin-inline: 0.5rem;
        }
      }
    }
  }

  .images {
    gap: 0.5rem;
    display: flex;
    align-items: center;

    img {
      max-width: 5rem;
    }
  }

  @media (max-width: 550px) {
    gap: 1rem;
    flex-direction: column;
  }
`